import React, { FC } from 'react';
import { Form, Button } from 'react-bootstrap';
import { urls } from '../../services/Server';

interface Props {
  equityId: string;
}

const AddSearchEquityForm: FC<Props> = ({ equityId }) => (
  <Form method="post" action={urls.userEquities}>
    <input name="externalid" type="hidden" value={equityId} />
    <Form.Group>
      <h5>Legg til i portefølje</h5>
    </Form.Group>
    <Form.Group controlId="stockholding">
      <Form.Label>Antall</Form.Label>
      <Form.Control
        required
        type="number"
        name="stockholding"
        step="0.0001"
        placeholder="Antall"
      />
    </Form.Group>

    <Form.Group controlId="totalprice">
      <Form.Label>Kostpris</Form.Label>
      <Form.Control
        required
        type="number"
        name="totalprice"
        step="0.01"
        placeholder="Kostpris"
      />
    </Form.Group>

    <Form.Group controlId="date">
      <Form.Label>Dato inv.</Form.Label>
      <Form.Control type="date" name="date" placeholder="Dato investert" />
    </Form.Group>

    <Form.Group>
      <Button variant="success" type="submit">
        Legg til
      </Button>
    </Form.Group>
  </Form>
);

export default AddSearchEquityForm;
